var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6647 13.3334V8.33341C28.6647 7.89139 28.4891 7.46746 28.1766 7.1549C27.864 6.84234 27.4401 6.66675 26.998 6.66675H10.3314C9.44733 6.66675 8.59948 7.01794 7.97436 7.64306C7.34924 8.26818 6.99805 9.11603 6.99805 10.0001M6.99805 10.0001C6.99805 10.8841 7.34924 11.732 7.97436 12.3571C8.59948 12.9822 9.44733 13.3334 10.3314 13.3334H30.3314C30.7734 13.3334 31.1973 13.509 31.5099 13.8216C31.8225 14.1341 31.998 14.5581 31.998 15.0001V20.0001M6.99805 10.0001V30.0001C6.99805 30.8841 7.34924 31.732 7.97436 32.3571C8.59948 32.9822 9.44733 33.3334 10.3314 33.3334H30.3314C30.7734 33.3334 31.1973 33.1578 31.5099 32.8453C31.8225 32.5327 31.998 32.1088 31.998 31.6667V26.6667M33.6647 20.0001V26.6667H26.998C26.114 26.6667 25.2661 26.3156 24.641 25.6904C24.0159 25.0653 23.6647 24.2175 23.6647 23.3334C23.6647 22.4494 24.0159 21.6015 24.641 20.9764C25.2661 20.3513 26.114 20.0001 26.998 20.0001H33.6647Z",
    stroke: "#353343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.af74ad262ad74720d5e45bba88bb5405.svg";
export { ForwardRef as ReactComponent };